import {
  DeleteOutlined,
  EditOutlined,
  LockOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { render } from "@testing-library/react";
import { Dropdown, Space, Table, Tag, Switch } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
function UserTable({
  isLoading = false,
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onStatus = () => { },
  resetPassword = () => { },
  onChange = () => { },
  pagination = {},
  onChangePassword = () => { }
}) {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  const columns = useCallback(
    () => {
      return [
        {
          title: (
            <div className="text-table">
              {t("user_management.label.employee_id")}
            </div>
          ),
          dataIndex: "employeeNo",
          key: "employeeNo",
          // sorter: (a, b) => a.employeeNo - b.employeeNo,
          sorter: true,
          width: 130,
          render: (_, record) => {
            if (record?.employeeNo === null) {
              return "-";
            }
            return <span
              style={{
                color: "#42526D",
                backgroundColor: "#F5F6F7",
                borderRadius: "20px",
                width: "max-content",
                height: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                margin: "auto",
                padding: "8px 16px"
              }}
            >
              {record?.employeeNo}
            </span>;
          },
          align: "center"
        },
        {
          title: (
            <div className="text-table">
              {t("user_management.label.fullname")}
            </div>
          ),
          dataIndex: i18n.language == 'en' ? "nameEn" : "name",
          key: "fullName",
          render: (_, record) => {
            const name =
              i18n.language === "en" ? record?.nameEn + " " + record?.surNameEn : record?.name + " " + record?.surName;
            return name;
          },
          sorter: true,
          width: 200,
        },
        {
          title: (
            <div className="text-table">
              {t("user_management.label.email")}
            </div>
          ),
          dataIndex: "email",
          key: "email",
          render: (_, record) => {
            const name =
              record?.userRegister?.username;
            return name;
          },
          sorter: true,
          width: 300,
        },
        {
          title: (
            <div className="text-table">
              {t("user_management.label.role")}
            </div>
          ),
          dataIndex: "role",
          key: "role",
          render: (_, record) => {
            const roles = record?.role?.map?.((role) => {
              return i18n.language === "en" ? role.nameEn : role.name;
            });
            return roles?.join(", ");
          },
          sorter: true,
          width: 200,
        },
        // {
        //   title: (
        //     <div className="text-table">
        //       {t("tab.menu.label.supervisor")}
        //     </div>
        //   ),
        //   dataIndex: "directSupervisor",
        //   key: "directSupervisor",
        //   render: (_, record) => {
        //     const supervisors = record?.supervisor?.map?.((supervisor) => {
        //       return i18n.language === "en" ? supervisor?.nameEn + " " + supervisor.surNameEn : supervisor?.name + " " + supervisor.surName;
        //     });
        //     return supervisors?.join(" , ");
        //   },
        //   // sorter: (a, b) => a.directSupervisor.length - b.supervisor.length,
        // },

        {
          title: (
            <div className="text-table">
              {t("user_management.label.status")}
            </div>
          ),
          key: "statusUser",
          dataIndex: "userRegister.userStatusFlag",
          align: "center",
          width: 100,
          render: (text, record) => (
            <Switch
              checked={record?.userRegister?.userStatusFlag === "ACTIVE" ? true : false}
              onChange={(checked) => onStatus(checked, record)}
            />
          ),
          sorter: true,
        },
        {
          title: "",
          key: "action",
          fixed: "right",
          align: "center",
          width: 70,
          render: (_, record) => (
            <Space size="middle">
              <Dropdown
                menu={{
                  items: [
                    roles.includes("UPDATE_USER_MANAGEMENT|USER_LIST") && {
                      key: "1",
                      onClick: () => onEdit(record),
                      label: `${t("action.edit")}`,
                      icon: (
                        <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                      ),
                    },
                    {
                      key: "2",
                      onClick: () => resetPassword(record),
                      label: `${t("action.reset_password")}`,
                      icon: (
                        <LockOutlined style={{ fontSize: "18px", color: "gray" }} />
                      ),
                    },
                    {
                      key: "3",
                      onClick: () => onChangePassword(record),
                      label: `${t("action.change_password")}`,
                      icon: (
                        <LockOutlined style={{ fontSize: "18px", color: "gray" }} />
                      ),
                    },
                    // roles.includes("DELETE_USER_MANAGEMENT|USER_LIST") && {
                    //   key: "3",
                    //   label: (
                    //     <p
                    //       onClick={() => onDelete(null, record, true)}
                    //       style={{ color: "grey", fontSize: "14px" }}
                    //     >
                    //       {t("action.delete")}
                    //     </p>
                    //   ),
                    //   icon: (
                    //     <DeleteOutlined
                    //       style={{ fontSize: "18px", color: "gray" }}
                    //       onClick={() => onDelete(null, record, true)}
                    //     />
                    //   ),
                    // },
                  ],
                }}
              >
                <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
              </Dropdown>
            </Space>
          ),
        },
      ];
    },
    [i18n.language, roles],
  )


  return (
    <TableAntd
      loading={isLoading}
      columns={columns()}
      dataSource={dataSource}
      scroll={{ x: true }}
      rowKey={(record) => record?.id}
      onChange={onChange}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
    />
  );
}

export default UserTable;
